import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';
import { authContext } from './auth';

export const DataUtilsContext = createContext(null);

export const useDataUtils = () => useContext(DataUtilsContext);

const DataUtilsProvider = ({ children }) => {

  const [listCountry, setListCountry] = useState([]);
  const [listCity, setListCity]= useState([]);
  const [listUf, setListUf] = useState([]);
  const [listIes, setListIes]= useState([]);
  const [listHigherCourses, setListHigherCourses]= useState([]);
  const [listPostgraduations, setListPostgraduations]= useState([]);
  const [listKnowledgeAreas, setListKnowledgeAreas] = useState([]);

  const { auth } = useContext(authContext);

  useEffect(() => {
    if (!auth) {
      setListCountry([]);
      setListCity([]);
      setListUf([]);
      setListIes([]);
      setListHigherCourses([]);
      setListPostgraduations([]);
      setListKnowledgeAreas([]);
      return;
    }

    const fetchData = async () => {
      try {
        const [
          countryRes,
          cityRes,
          ufRes,
          iesRes,
          higherCourseRes,
          postgraduationRes,
          knowledgeAreaRes,
        ] = await Promise.all([
          api.get('/resource/country/list'),
          api.get('/resource/city/list'),
          api.get('/resource/city/list-by-uf'),
          api.get('/resource/ies/list'),
          api.get('/resource/higher-course/list'),
          api.get('/resource/postgraduation'),
          api.get('/resource/knowledge-area/list'),
        ]);

        setListCountry(countryRes.data);
        setListCity(cityRes.data);
        setListUf(ufRes.data);
        setListIes(iesRes.data);
        setListHigherCourses(higherCourseRes.data);
        setListPostgraduations(postgraduationRes.data);
        setListKnowledgeAreas(knowledgeAreaRes.data);
      } catch (err) {
        console.error('Erro ao carregar dados utilitários', err);
        // Aqui você pode disparar um toast ou redirecionar, se quiser
      }
    };

    fetchData();
  }, [auth]);

  const value = {
    listCountry,
    listCity,
    listUf,
    listIes,
    listHigherCourses,
    listPostgraduations,
    listKnowledgeAreas,
  };

  return (
    <DataUtilsContext.Provider value={value}>
      {children}
    </DataUtilsContext.Provider>
  );
};

export default DataUtilsProvider;
